/**
 * @since: 2020-04-27
 * @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'
import {base64Decode} from '~/utils/base64'

export const state = () => ({
  // REST API
  preDefinedGroupUrl: '/api/op/dlp/data-group/predefined/objects',
  userDefinedGroupUrl: '/api/op/dlp/data-group/userdefined/objects',
  groupObjectCommitUrl: '/api/op/dlp/data-group',
  txtDlpGroupObjectAllDataUrl: '/api/op/dlp/data-group/objects',
  txtDlpFileTypesUrl: '/api/op/dlp/filetype/types',
  getDlpDataGroupObjectData: [],
  dlpDataObjectListBasic: [],
  dlpDataObjectListUser: [],
  getDlpUsrDataGroupObjectData: [],
  getGroupObjectAllData: [],
  fileTypeOption: [],
  basicRowSelectItems: [],
  userRowSelectItems: []
})

const getDataValue = (state, item) => {
  let txt = ''
  if (item.dlp_data_obj_add_info_value_type === 3) {
    txt = item.dlp_data_obj_add_info_value2
  } else if (item.dlp_data_obj_add_info_value_type === 4) {
    _.forEach(state.fileTypeOption, o => {
      if (item.dlp_data_obj_add_info_value2 === o.value) {
        txt = o.label
      }
    })
  } else {
    txt = base64Decode(item.dlp_data_obj_add_info_value1)
  }
  return txt
}

export const mutations = {
  clearStore: (state) => {
    state.getDlpDataGroupObjectData = []
    state.dlpDataObjectListBasic = []
    state.dlpDataObjectListUser = []
    state.getDlpUsrDataGroupObjectData = []
    state.getGroupObjectAllData = []
    state.fileTypeOption = []
    state.basicRowSelectItems = []
    state.userRowSelectItems = []
  },
  setBasicRowSelectItems: (state, data) => {
    state.basicRowSelectItems = _.cloneDeep(data)
  },
  setUserRowSelectItems: (state, data) => {
    state.userRowSelectItems = _.cloneDeep(data)
  },
  preDefineHeaderMutation: (state, data) => {
    state.getDlpDataGroupObjectData = _.map(state.getDlpDataGroupObjectData, (item) => {
      item.dlp_data_obj_use = _.cloneDeep(data)
      return item
    })
  },
  userDefineHeaderMutation: (state, data) => {
    state.getDlpUsrDataGroupObjectData = _.map(state.getDlpUsrDataGroupObjectData, (item) => {
      item.dlp_data_obj_use = _.cloneDeep(data)
      return item
    })
  },
  getGroupObjectAllDataAction: (state, data) => {
    state.getGroupObjectAllData = _.cloneDeep(data)
  },
  getDlpDataGroupObjectDataAction: (state, data) => { // 기본 데이터 그룹 조회
    state.getDlpDataGroupObjectData = _.cloneDeep(data)
  },
  getDlpDataObjectListBasic: (state, data) => {
    state.dlpDataObjectListBasic = _.map(data.mmbr_dlp_data_obj_list, (item) => {
      item.dlp_data_value = getDataValue(state, item)
      return item
    })
  },
  getDlpDataObjectListUser: (state, data) => {
    state.dlpDataObjectListUser = _.map(data.mmbr_dlp_data_obj_list, (item) => {
      item.dlp_data_value = getDataValue(state, item)
      return item
    })
  },
  getDlpUsrDataGroupObjectDataAction: (state, data) => { // 사용자 정의 데이터 그룹 객체 조회
    state.getDlpUsrDataGroupObjectData = _.cloneDeep(data)
  },
  addDlpUsrDataGroupObjectDataAction: (state, data) => { // 사용자 정의 그룹 데이터 추가
    state.getDlpUsrDataGroupObjectData.push(data)
  },
  editDlpUsrDataGroupObjectDataAction: (state, data) => { // 사용자 정의 데이터 그룹 객체 편집
    state.getDlpUsrDataGroupObjectData = _.map(state.getDlpUsrDataGroupObjectData, (item) => {
      if (item.dlp_data_obj_id === data.dlp_data_obj_id) {
        item = _.cloneDeep(data)
      }
      return item
    })
  },
  getFileTypeOption: (state, data) => {
    state.fileTypeOption = []
    if (data) {
      _.forEach(data, item => {
        state.fileTypeOption.push({label: item.dlp_data_obj_name, value: String(item.dlp_file_type_id)})
      })
    }
  }
}

export const actions = {
  async getGroupObjectAllDataAction ({commit, state}) { // 데이터 그룹 객체 목록 조회 (추가, 편집 창에서 사용)
    try {
      const data = await this.$axios.$get(state.txtDlpGroupObjectAllDataUrl, '', {
        applyMsg: false,
        cancelMsg: false,
        successAlert: false,
        loading: false,
        loadingShow: false,
        loadingHide: false
      })
      return resultFactory(commit, {length: null, data: data, action: 'getGroupObjectAllDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 기본 데이터 그룹 조회
  async getDlpDataGroupObjectDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.preDefinedGroupUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpDataGroupObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 기본 데이터 그룹 일괄 수정
  async editDlpDataGroupObjectListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(state.preDefinedGroupUrl, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 기본 데이터 그룹, 하단 테이블 조회
  async getDlpDataObjectListBasic ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.preDefinedGroupUrl}/${state.basicRowSelectItems[0].dlp_data_obj_id}`)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpDataObjectListBasic', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 정의 데이터 그룹, 하단 테이블 조회
  async getDlpDataObjectListUser ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.userDefinedGroupUrl}/${state.userRowSelectItems[0].dlp_data_obj_id}`)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpDataObjectListUser', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 정의 데이터 그룹 객체 조회
  async getDlpUsrDataGroupObjectDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.userDefinedGroupUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpUsrDataGroupObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addDlpUsrDataGroupObjectDataAction ({commit, state}, payload) { // 그룹 데이터 추가
    try {
      const data = await this.$axios.$post(state.userDefinedGroupUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addDlpUsrDataGroupObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 정의 데이터 그룹 객체 편집
  async editDlpUsrDataGroupObjectDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.userDefinedGroupUrl}/${state.userRowSelectItems[0].dlp_data_obj_id}`, payload)
      return resultFactory(commit, {
        length: null,
        data: data,
        action: 'editDlpUsrDataGroupObjectDataAction',
        param: null
      })
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 데이터 일괄수정
  async editDlpUsrDataGroupObjectListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(state.userDefinedGroupUrl, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delDlpUsrDataGroupObjectDataAction ({commit, state}) { // 사용자 정의 데이터 그룹 객체 삭제
    let isMulty = false
    const idList = []
    if (state.userRowSelectItems.length > 1) {
      isMulty = true
      state.userRowSelectItems.forEach((item) => {
        idList.push({'dlp_data_obj_id': item.dlp_data_obj_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.userDefinedGroupUrl, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.userDefinedGroupUrl}/${state.userRowSelectItems[0].dlp_data_obj_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.groupObjectCommitUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async getFileTypeOption ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtDlpFileTypesUrl}`)
      return resultFactory(commit, {length: null, data: data, action: 'getFileTypeOption', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
